import { z } from 'zod';

export const ExternalRefSchema = z.object({
  source: z.string().min(1).max(64), // 'close.com' | 'sfr_analytics' | 'manual_entry' | 'hubspot' | 'salesforce'
  externalId: z.string().min(1).max(256),
  linkedAt: z.string().datetime(), // ISO8601 UTC
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export type ExternalRef = z.infer<typeof ExternalRefSchema>;

export function appendExternalRef(existing: ExternalRef[] | null | undefined, ref: ExternalRef): ExternalRef[] {
  const arr = existing ?? [];
  const idx = arr.findIndex((r) => r.source === ref.source && r.externalId === ref.externalId);
  if (idx >= 0) {
    const next = [...arr];
    next[idx] = ref; // newer linkedAt wins
    return next;
  }
  return [...arr, ref];
}

export function findByExternalRef(
  refs: ExternalRef[] | null | undefined,
  source: string,
  externalId: string,
): ExternalRef | undefined {
  return refs?.find((r) => r.source === source && r.externalId === externalId);
}
